import { Banner, BannerTypes } from "@sunrun/experience-ui-components";

const UTILITY_BILL_UPLOAD_MESSAGE =
  "Please upload a utility bill and confirm kWh usage entered matches kWh usage on bill";

const OfferReviewUtilityBillUploadBanner = ({
  onClickPrimaryAction,
}: {
  onClickPrimaryAction: () => void;
}) => {
  return (
    <Banner
      bannerType={BannerTypes.InfoLight}
      show={true}
      showClose={false}
      showIcon={true}
      data-testid="offer-review-utility-bill-upload-banner"
      primaryAction={{
        title: "Upload",
        action: onClickPrimaryAction,
        testId: "offer-review-upload-utility-bill-button",
      }}
    >
      {UTILITY_BILL_UPLOAD_MESSAGE}
    </Banner>
  );
};

export { OfferReviewUtilityBillUploadBanner, UTILITY_BILL_UPLOAD_MESSAGE };
